<template>
  <div>
    <!-- Título da página -->
    <b-row>
      <b-col cols="12" class="mb-4">
        <PageTitle title="Impulsionar produtos" />
      </b-col>
    </b-row>

    <!-- Formulário para adicionar nova regra -->
    <b-row>
      <b-col cols="9" class="mb-4">
        <label>Termo buscado</label>
        <input type="text" class="form-control" v-model="form.nome" />
      </b-col>

      <b-col cols="1" class="mb-4">
        <label>Like</label>
        <span
          class="ml-2"
          v-b-tooltip.hover
          title="Se tiver o texto em qualquer parte da busca, já retorna os itens!"
        >
          <i class="fas fa-info-circle"></i>
        </span>
        <input type="checkbox" class="form-control" v-model="form.like" />
      </b-col>

      <b-col cols="1" class="mb-4">
        <label>Busca</label>
        <span
          class="ml-2"
          v-b-tooltip.hover
          title="Retornar somente os itens adicionados!"
        >
          <i class="fas fa-info-circle"></i>
        </span>
        <input type="checkbox" class="form-control" v-model="form.search" />
      </b-col>

      <b-col cols="12" class="text-center mb-4">
        <button class="btn btn-primary" @click="addImpusionar">Adicionar regra</button>
      </b-col>
    </b-row>

    <!-- Lista de regras (accordion) -->
    <div class="accordion" role="tablist">
      <b-row>
        <b-col
          cols="12"
          class="mb-4"
          v-for="(item, i) in rules"
          :key="item.id || i"
        >
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                v-b-toggle="'accordion-' + i"
                variant="dark"
                type="button"
                @click="getProducts(item.id)"
              >
                {{ item.nome }}
              </b-button>
            </b-card-header>

            <b-collapse :id="'accordion-' + i" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-row>
                  <b-col cols="4" class="mb-4">
                    <label>Termo buscado</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.nome"
                    />
                  </b-col>

                  <b-col cols="5" class="mb-4">
                    <label>Slug</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.descricao"
                      readonly
                    />
                  </b-col>

                  <b-col cols="1" class="mb-4">
                    <label>Like</label>
                    <span
                      class="ml-2"
                      v-b-tooltip.hover
                      title="Se tiver o texto em qualquer parte da busca, já retorna os itens!"
                    >
                      <i class="fas fa-info-circle"></i>
                    </span>
                    <input type="checkbox" class="form-control" v-model="item.like" />
                  </b-col>

                  <b-col cols="1" class="mb-4">
                    <label>Busca</label>
                    <span
                      class="ml-2"
                      v-b-tooltip.hover
                      title="Retornar somente os itens adicionados!"
                    >
                      <i class="fas fa-info-circle"></i>
                    </span>
                    <input type="checkbox" class="form-control" v-model="item.search" />
                  </b-col>

                  <b-col cols="1" class="mb-4">
                    <label>Status</label>
                    <input type="checkbox" class="form-control" v-model="item.status" />
                  </b-col>

                  <b-col cols="12" class="text-center mb-4">
                    <button class="btn btn-success" @click="updateImpusionar(i)">
                      Atualizar regra
                    </button>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <b-row>
                      <b-col cols="6" class="pr-0">
                        <label>Produto</label>
                        <input type="text" class="form-control" placeholder="Nome do produto, cód barras" v-model="texto">
                      </b-col>
                      <b-col cols="2" class="pr-0">
                        <label>Cód. int</label>
                        <input type="text" class="form-control" placeholder="XXXXXX" v-model="codInt">
                      </b-col>
                      <b-col cols="2" style="display: flex;align-items: end;">
                        <button class="btn btn-warning btn-block" @click="clearProducts(item.id)">
                          <i class="fas fa-ban"></i>
                          Limpar
                        </button>
                      </b-col>
                      <b-col cols="2" style="display: flex;align-items: end;">
                        <button class="btn btn-success btn-block" @click="getProducts(item.id)">
                          <i class="fas fa-search"></i>
                          Pesquisar
                        </button>
                      </b-col>
                    </b-row>

                    <table class="table table-striped table-bordered  mt-2">
                      <thead>
                        <tr>
                          <th style="width:20%" class="text-center">Foto</th>
                          <th style="width:45%">Produto</th>
                          <th style="width:10%">Cód. barras</th>
                          <th style="width:10%">Cód. int</th>
                          <th style="width:10%" class="text-center">Ação</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, index) in products" :key="index">
                          <td class="text-center">
                            <b-img
                              :src="linkImage(product.photo)"
                              width="50"
                            ></b-img>
                          </td>
                          <td>{{product.product}}</td>
                          <td>{{product.codbar}}</td>
                          <td>{{product.codInterno}}</td>
                          <td class="text-center">
                            <button
                              v-if="product.impusiona == false"
                              class="btn btn-success btn-ico"
                              @click="addImpusionaId(product.id, product.impusionaId), product.impusiona = true"
                            >
                              <i class="fas fa-plus"></i>
                            </button>
                            <button
                              v-if="product.impusiona == true"
                              class="btn btn-danger btn-ico"
                              @click="dellImpusionaId(product.id, product.impusionaId), product.impusiona = false"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PageTitle from '@/components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'ProductBoost',
  mixins: [makeToast],
  components: { PageTitle },
  data() {
    return {
      loading: false,
      rules: [],
      products: [],
      texto: '',
      codInt: '',
      form: {
        nome: '',
        descricao: '',
        like: false,
        search: false,
        status: true,
        lojista_id: null,
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  mounted() {
    this.fetchRules();
  },
  methods: {
    ...mapActions('shopkeeper', [
      'getImpusionarProduto',
      'saveImpusionarProduto',
      'updateImpusionarProduto',
      'listImpusionarProdutos',
      'newImpusionaId',
      'deleteImpusionaId'
    ]),

    fetchRules() {
      this.$store.dispatch('startLoader');
      this.getImpusionarProduto(this.userTypeId())
        .then((response) => {
          this.rules = response.data;
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    addImpusionar() {
      if (!this.form.nome) {
        this.makeToast('Erro', 'Informe o campo termo buscado para adicionar!', 'danger');
        return;
      }

      this.form.lojista_id = this.userTypeId();
      this.$store.dispatch('startLoader');
      this.saveImpusionarProduto(this.form)
        .then((response) => {
          if (response.data.error == true) {
            this.makeToast('Erro', response.data.message, 'danger');
          } else {
            this.makeToast('Sucesso', response.data.message);
            this.resetForm();
            this.fetchRules();
          }
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    clearProducts(id) {
      this.texto = '';
      this.codInt = '';
      this.getProducts(id);
    },
    getProducts(id) {
      const data = {
        userId: this.userTypeId(),
        productName: this.texto,
        codInt: this.codInt,
        termoId: id
      }

      this.$store.dispatch('startLoader');
      this.listImpusionarProdutos(data)
        .then((response) => {
          this.products = response.data.data;
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    addImpusionaId(selectId, termoId) {
      const data = {
        userId: this.userTypeId(),
        selectId: selectId,
        termoId: termoId
      }

      this.$store.dispatch('startLoader');
      this.newImpusionaId(data)
        .then(() => {
          this.makeToast('Sucesso', 'Produto adicionado na lista com sucesso!');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    dellImpusionaId(selectId, termoId) {
      const data = {
        userId: this.userTypeId(),
        selectId: selectId,
        termoId: termoId
      }

      this.$store.dispatch('startLoader');
      this.deleteImpusionaId(data)
        .then(() => {
          this.makeToast('Sucesso', 'Produto removido da lista com sucesso!');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    updateImpusionar(i) {
      const regra = this.rules[i];
      if (!regra.nome || !regra.descricao) {
        this.makeToast('Erro', 'Informe todos os campos para atualizar a regra!', 'danger');
        return;
      }

      regra.lojista_id = this.userTypeId();

      this.$store.dispatch('startLoader');
      this.updateImpusionarProduto(regra)
        .then((response) => {
          if (response.data.error == true) {
            this.makeToast('Erro', response.data.message, 'danger');
          } else {
            this.makeToast('Sucesso', response.data.message);
            this.fetchRules();
          }
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },

    resetForm() {
      this.form = {
        nome: '',
        descricao: '',
        like: false,
        search: false,
        status: true,
        lojista_id: null,
      };
    },
    linkImage(value) {
      return process.env.VUE_APP_FOTOS_URL + value;
    },
    userTypeId() {
      return this.$route.meta.userType === UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },

    // whatClerkPermission() {
    //   if (this.$route.meta.userType === UserTypes.BALCONISTA) {
    //     const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
    //     const permission = permissionClerk.find((el) => el.name === NamePermission.CRIAR_PRODUTO);
    //     if (permission?.type === TypePermission.BALCONISTA) {
    //       return false;
    //     }
    //   }
    //   return true;
    // },
  },
};
</script>
